import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const formUrl = 'https://readdy.ai/api/form/d9qogmfnahb7382ovctg';

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypotEl = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotEl && honeypotEl.value.trim() !== '') {
      setStatus('success');
      setEmail('');
      return;
    }

    if (!email.trim()) return;

    setStatus('submitting');
    try {
      const formData = new FormData(form);
      const response = await fetch(formUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后再试';
        const isSpam = typeof serverMsg === 'string' && serverMsg.includes('spam');
        if (isSpam || (typeof serverMsg === 'string' && serverMsg.includes('form data is spam'))) {
          setStatus('error');
          setErrorMsg('提交失败，请稍后再试');
        } else {
          setStatus('error');
          setErrorMsg(serverMsg);
        }
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请检查连接后重试');
    }
  };

  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-100">
      <div className="max-w-2xl mx-auto text-center">
        <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600">
          <i className="ri-mail-send-line text-2xl"></i>
        </div>
        <h2 className="mt-6 text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
          订阅我们的通讯
        </h2>
        <p className="mt-3 text-sm text-foreground-500 leading-relaxed max-w-md mx-auto">
          获取最新性健康科普文章和专业知识，关爱自己的身体。我们尊重您的隐私，绝不会分享您的信息。
        </p>

        {status === 'success' ? (
          <div className="mt-8 p-6 bg-accent-50 border border-accent-200/60 rounded-xl">
            <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
              <i className="ri-check-line text-lg"></i>
            </div>
            <p className="mt-3 text-sm font-medium text-accent-700">订阅成功！感谢您的关注。</p>
            <p className="mt-1 text-xs text-accent-500">我们会将最新文章发送到您的邮箱。</p>
          </div>
        ) : (
          <form
            data-readdy-form="newsletter-subscribe"
            onSubmit={handleSubmit}
            className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 max-w-md mx-auto"
          >
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="honeypot-field"
            />
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入您的邮箱地址"
              required
              className="flex-1 px-5 py-3.5 rounded-full border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder-foreground-300 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all duration-200"
            />
            <button
              type="submit"
              disabled={status === 'submitting'}
              className="px-7 py-3.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 disabled:opacity-60 disabled:cursor-not-allowed transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {status === 'submitting' ? '提交中...' : '免费订阅'}
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="mt-3 text-xs text-red-500">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}